export default {
  label: '地质工程师助理',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '地质工程师助理协助地质工程师完成矿山地质相关工作，包括地质调查、矿产资源评估及矿区规划',
          id: '0-1-1',
        }
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '参与矿山地质技术、储量管理及矿石品位质量等相关制度编制',
          id: '0-2-1',
        },
        {
          label: '协助采矿工程师完成年度、季度、月度计划及施工图设计',
          id: '0-2-2'
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '熟悉矿山地质技术及储量管理，具备一定的数据分析能力',
          id: '0-3-1',
        },
        {
          label: '具备良好的组织协调能力和沟通能力，能够处理复杂的地质问题',
          id: '0-3-2',
        }
      ],
    },
    {
      label: '薪资水平',
      id: '0-4',
      children: [
        {
          label: '应届生：约为6000元',
          id: '0-4-1',
        },
        {
          label: '采矿工程硕士：起薪在8000-12000元',
          id: '0-4-2',
        }
      ],
    },
    {
      label: '晋升方向',
      id: '0-5',
      children: [
        {
          label: '采矿工程师',
          id: '0-5-1',
        }
      ],
    }
  ],
};